import { OnInit, Component } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';



@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css'],

})
export class AccountsComponent implements OnInit {
  constructor(private accountService: AccountService) {

  }

  ngOnInit() {
    this.accountService.getCloudSearchUrlFromREST()
    .subscribe(res => {
     this.accountService.setCloudSearchUrl( res.toString());
    });
  }
}
